import * as React from 'react'
import { useFormikContext } from 'formik'
import TextInputFieldFormik from 'uiComponents/input/textInput/textInputFieldFormik'
import { Reveal } from 'uiComponents/reveal/reveal'
import { SkeletonBar } from 'uiComponents/skeleton/skeleton'
import { CONFIG } from 'capacity/copy'
import { CapacityFormValues } from 'capacity/staging/savePlan'
import { CapacityHealth, parseLimitInput } from 'capacity/types'
import { CountingTypeCards } from './countingTypeCards'

interface CapacityConfigCardProps {
    loading: boolean
    isNew: boolean
    health: CapacityHealth
}

export function CapacityConfigCard({ loading, isNew, health }: CapacityConfigCardProps) {
    const { values, setFieldValue } = useFormikContext<CapacityFormValues>()
    const limit = parseLimitInput(values.limit)

    return (
        <section className="capacity-card capacity-config" aria-label={CONFIG.heading}>
            {loading ? (
                <div className="capacity-config-skeleton" aria-busy="true">
                    <SkeletonBar width="40%" height="1rem" />
                    <SkeletonBar width="100%" height="2.5rem" />
                    <SkeletonBar width="30%" height="1rem" />
                    <SkeletonBar width="100%" height="6rem" />
                </div>
            ) : (
                <>
                    <Reveal open={health === 'noDefaultRule'}>
                        <p className="capacity-note capacity-note-warning">{CONFIG.noDefaultRule}</p>
                    </Reveal>
                    <div className="capacity-fields-row">
                        <div className="capacity-field">
                            <label className="capacity-field-label" htmlFor="capacity-name">
                                {CONFIG.name}
                            </label>
                            <p className="capacity-field-help">{CONFIG.nameHelp}</p>
                            <TextInputFieldFormik
                                id="capacity-name"
                                name="name"
                                placeholder={CONFIG.namePlaceholder}
                                validateOnChange
                            />
                        </div>
                        <div className="capacity-field">
                            <label className="capacity-field-label" htmlFor="capacity-limit">
                                {CONFIG.limit}
                            </label>
                            <p className="capacity-field-help">{CONFIG.limitHelp}</p>
                            <TextInputFieldFormik
                                id="capacity-limit"
                                name="limit"
                                inputMode="numeric"
                                placeholder={CONFIG.limitPlaceholder}
                                validateOnChange
                            />
                            <Reveal open={limit !== 'invalid' && limit.kind === 'closed'}>
                                <p className="capacity-note">{CONFIG.closed}</p>
                            </Reveal>
                        </div>
                    </div>
                    {isNew && (
                        <div className="capacity-field">
                            <span className="capacity-field-label" id="capacity-counting-label">
                                {CONFIG.howItCounts}
                            </span>
                            <CountingTypeCards
                                value={values.countingType}
                                onChange={(next) => setFieldValue('countingType', next)}
                            />
                        </div>
                    )}
                </>
            )}
        </section>
    )
}
